export let setAuthenticationToken = token => {
  console.log('setAuthenticationToken: token', token);
  localStorage.setItem('authenticationToken', JSON.stringify(token));
};
export let setRefreshToken = token => {
  console.log('setRefresh: token', token);
  localStorage.setItem('refreshToken', JSON.stringify(token));
};
export let getRefreshToken = () => {
  let token = JSON.parse(localStorage.getItem('refreshToken'));
  return token || null;
};

export let getAuthenticationToken = () => {
  let token = JSON.parse(localStorage.getItem('authenticationToken'));
  return token || null;
};
